import global from '../global.js';

export default {
  file: {
    fileReader: function() {
      return typeof global.FileReader !== 'undefined';
    },
  },
};
